import { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import api from "../../../api";

export default function DeleteSurveyInstanceModal({ instanceId, patientName, show, onHide, onDeleted }) {

  const [requestErrorMessage, setRequestErrorMessage] = useState("");

  const deleteInstance = () => {
    api.delete(`/SurveyInstance/${instanceId}`)
      .then(() => {
        onDeleted();
        onHide();
      })
      .catch(error => {
        console.log(error.message);
        if (error.response) {
          setRequestErrorMessage(error.response.data.title);
          return;
        }
        setRequestErrorMessage(error.message);
      });
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ background: "rgba(0, 0, 0, 0.6)" }}
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Usuwanie ankiety
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Czy na pewno chcesz usunąć ankietę pacjenta: <b>{patientName}</b>.<br />
        Tej czynności nie można odwrócić!
        <br />

        <Button
          onClick={deleteInstance}
          variant="danger"
          className="m-5"
        >
          Usuń
        </Button>
        {requestErrorMessage && <h3 className="text-danger">{requestErrorMessage}</h3>}
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={onHide}>Zamknij</Button>
      </Modal.Footer>
    </Modal>
  );
}
